import 'bootstrap';
import AOS from 'aos';
import 'slick-carousel';

const $ = require('jquery');

global.$ = $;
global.jQuery = $;

require('popper.js');
require('jquery.easing');

document.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 1200,
	});
});
